export const config = {
  dots: false,
  infinite: false,
  slidesToScroll: 1,
  slidesToShow: 8,
  speed: 150,
};
